

import { db } from "../Auth/config";
import {
  collection,
  getDocs,
  getDoc,
  addDoc,
  updateDoc,
  deleteDoc,
  doc, setDoc, query, where,
} from "firebase/firestore";







export const following = async (followingId, userid ,obj) => {

  return await setDoc(doc(db, `followerfollowing/${userid}/following`, `${followingId}`), {
    obj
  });


};

export const follower = async (followingId, userid,obj) => {

  return await setDoc(doc(db, `followerfollowing/${followingId}/follower`, `${userid}`), {
    obj
  });

};


export const followingDel = async (followingId, userid) => {

  await deleteDoc(doc(db, `followerfollowing/${userid}/following`, `${followingId}`));

};

export const followerDel = async (followingId, userid) => {

  await deleteDoc(doc(db, `followerfollowing/${followingId}/follower`, `${userid}`));

};

export const getAllfollowfollowing = async (userid) => {
  let followingdatadb=[]


  const q = query(collection(db, `followerfollowing/${userid}/following`));
  const querySnapshot = await getDocs(q);
  querySnapshot.forEach((doc) => {
    
    
    followingdatadb=[...followingdatadb,doc.data(),]
  });
  return followingdatadb

};

export const getAllfollowfollower = async (userid) => {
  let followerdatadb=[]
  const q = query(collection(db, `followerfollowing/${userid}/follower`));
  
  const querySnapshot = await getDocs(q);
  
  querySnapshot.forEach((doc) => {
    
    followerdatadb=[...followerdatadb,doc.data(),]
  });
  return followerdatadb

};


